<template>
  <Card dis-hover>
    <!-- 不合格点检项 -->
    <div slot="title">
      <slot name="title"></slot>
      <p class="title-item">{{ this.$t('common.this_month') }}</p>
    </div>
    <!-- <a href="#" slot="extra">
      <slot name="extra"></slot>
    </a> -->
    <div class="content">
      <Table :columns="columns" :data="checkData" size="small">
        <!-- <template slot-scope="{ row }" slot="indexl">
          <div class="item-rank">{{ row._index + 1 }}</div>
        </template> -->
        <template slot-scope="{ row }" slot="checkItem">
          <!-- <Tooltip max-width="200" :content="row.name"> -->
          <span class="row-name" style="font-size: 13px" :title="row.name">{{ row.name }}</span>
          <!-- </Tooltip> -->
        </template>
        <template slot-scope="{ row }" slot="failureRate">
          <div class="space-add">
            <span style="font-size: 12px; position: relative; top: 12px; color: #ff482d"
              >{{ parseInt(row.rate * 100) }}%</span
            >
            <Progress :percent="parseInt(row.rate * 100)" :stroke-width="2" hide-info stroke-color="#FF482D" />
          </div>
        </template>
        <template slot-scope="{ row }" slot="checkTimes">
          <div>
            <span style="font-size: 12px; position: relative; top: 12px; color: #2bb1d8">{{ row.num }}</span>
            <Progress :percent="getPercent(row.num)" :stroke-width="2" hide-info stroke-color="#2BB1D8" />
          </div>
        </template>
      </Table>
    </div>
    <Spin size="large" v-if="isLoading" fix></Spin>
  </Card>
</template>
<script>
import api from '../../../api/home/index';
export default {
  data() {
    return {
      sortWay: 'top',
      columns: [
        {
          type: 'index',
          width: '60px',
          align: 'center',
          title: ' ',
        },
        {
          title: this.$t('common.check_item'),
          slot: 'checkItem',
          width: '145px',
        },
        {
          title: this.$t('common.unqualified_rate'),
          slot: 'failureRate',
          sortable: true,
          key: 'rate',
        },
        {
          title: this.$t('common.check_times'),
          slot: 'checkTimes',
          sortable: true,
          key: 'num',
        },
      ],
      isLoading: false,
      checkData: [],
    };
  },
  computed: {
    totalNum() {
      let a = [];
      for (let i = 0; i < this.checkData.length; i++) {
        a.push(this.checkData[i].num);
      }
      // console.log("fff",a)
      return Math.max.apply(null, a);
    },
  },

  mounted() {
    this.getData();
  },
  methods: {
    // 获取不合格点检项
    getData() {
      this.checkData = [];
      let params = {
        timeRange: 5,
        tagIdList: [],
        sourceTypeList: [],
        showCompare: 0,
        deptNode: [],
        checkerType: 2,
        role: [],
        user: [],
        templateId: [],
        sort: 'desc',
      };
      api
        .evaluationUnqualifiedRateTop(params)
        .then(res => {
          // 初始化echarts
          this.checkData = res;
        })
        .catch(e => {
          console.log(e)
          this.$Message.error(`error`);
        });
    },
    getPercent(a) {
      // console.log(a/this.totalNum)
      return parseInt((a / this.totalNum) * 100);
    },
  },
};
</script>
<style lang="less" scoped>
.top-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title {
    display: inline-block;
    margin-right: 5px;
    font-weight: 600;
    font-size: 16px;
    color: #333333;
  }
}

::v-deep {
  .ivu-card-head p {
    width: auto;
  }
  .ivu-card-body {
    padding-top: 0;
    overflow-y: auto;
  }
}
.title-item {
  padding: 0 5px;
  height: 18px;
  background: rgba(255, 255, 255, 0.11);
  border-radius: 3px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 12px;
  color: #b2b2b2;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
  margin-left: 6px;
}
.space-add {
  padding-right: 8px;
}
.item-rank {
  font-size: 12px;
  font-weight: 600;
  display: inline-block;
  width: 22px;
  height: 22px;
  line-height: 22px;
  border-radius: 6px;
  background: #f0f0f0;
  color: #333333;
  text-align: center;
}
.row-name {
  display: inline-block;
  width: 130px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
::v-deep {
  .ivu-table th {
    font-size: 12px;
    color: #b2b2b2;
    background: none !important;
    border-bottom: none !important;
  }
  .ivu-table td {
    background: none !important;
    color: #e6e6e6;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15) !important;
  }
  .ivu-table {
    background: none !important;
    &::before {
      background: none !important;
    }
  }
  .ivu-table-cell {
    padding: 0px;
  }
  .ivu-table-overflowY::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 3px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  .ivu-table-overflowY::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px #cccccc;
    background: #cccccc;
  }
  .ivu-table-overflowY::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px #fff;
    border-radius: 10px;
    background: #fff;
  }

  .ivu-table-tbody {
    .ivu-table-row {
      td:first-child {
        span {
          font-size: 12px;
          font-weight: 600;
          display: inline-block;
          width: 22px;
          height: 22px;
          line-height: 22px;
          border-radius: 6px;
          background: rgba(255, 255, 255, 0.1) !important;
          color: #252525;
          text-align: center;
        }
      }
    }
  }
}
</style>
